import React from "react";
import DialogTitle from "./dialog-title";
import Dialog from "@material-ui/core/Dialog/Dialog";

const SaveChanges = props => {
  return (
    <Dialog
      open={props.save}
      aria-labelledby="form-dialog-confirm"
      fullWidth
      maxWidth="xs"
    >
      <DialogTitle id="form-dialog-confirm">Сохранено</DialogTitle>
    </Dialog>
  );
};

export default SaveChanges;
